<template>
    <div class="container datalogger-index-container">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="card-header-label col-2">
                        <span class="mdi mdi-antenna custom-icon"></span>
                        <span>Dataloggers</span>
                    </div>
                    <div class="card-header-search-bar col-5">
                        <input type="text" v-model="filter" id="filter-input" placeholder="Escriba aquí el texto a buscar" class="form-control">
                    </div>
                    <div class="card-header-pagination col-3">
                        <b-pagination 
                            v-model="currentPage" 
                            :total-rows="filteredList ? filteredList.length : 0"
                            :per-page="perPage" 
                            aria-controls="dataloggers-index-table" 
                            style="margin: 0;"
                            align="center" 
                        />
                    </div>
                    <div class="card-header-action-buttons col-2">
                        <div>
                            <ButtonComponent
                                v-if="canCreateDatalogger"
                                :buttonText="'Nuevo'"
                                :buttonColor="colors.GREEN_COLOR_BUTTON"
                                :buttonAction="() => openDataloggerModal(false)"
                            />
                            <ButtonComponent
                                v-if="canCreateDatalogger"
                                :buttonText="'Refrescar'"
                                :buttonColor="colors.BLUE_COLOR_BUTTON"
                                :buttonAction="refreshDataloggers"
                            />
                        </div>
                    </div>
                </div>
            </div>
                <div v-if="isLoading" style="padding: 5ch 0;">
                    <SpeenComponent  
                        :isAutomatic="true" 
                        :ringWidth="14" 
                        :spinnerSize="15" 
                        :isverticalAligned="true"
                    />
                </div>
            <div class="card-body" v-else>
                <b-table 
                    id="dataloggers-index-table" 
                    striped 
                    hover 
                    :items="filteredList" 
                    :fields="fields" 
                    responsive 
                    :per-page="perPage" 
                    :current-page="currentPage"
                    >
                    <template v-slot:cell(use_tls)="data">
                        <span v-if="data.item.use_tls === 1">Sí</span>
                        <span v-else>No</span>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <ButtonComponent
                            v-if="data.item && canEditDatalogger"
                            :buttonText="'Editar'"
                            :buttonColor="colors.GREEN_COLOR_BUTTON"
                            :buttonAction="() => openDataloggerModal(data.item)"
                        />
                        <ButtonComponent
                            v-if="data.item && canDeleteDatalogger"
                            :buttonText="'Borrar'"
                            :buttonColor="colors.RED_COLOR_BUTTON"
                            :buttonAction="() => confirmDeleteDatalogger(data.item)"
                        />
                    </template>
                </b-table>
            </div>
            <transition name="slide-fade">
                <ActionConfirmModal
                    v-if="showActionConfirmModal"
                    :contentMessage="actionConfirmModalMessage"
                    :closeModal="closeActionConfirmModal"
                    :methodForProp="methodForProp"
                />
                <DataloggerModal
                    v-if="showDataloggerModal"
                    :selectedDatalogger="selectedDatalogger"
                    :isNewDatalogger="isNewDatalogger"
                    @close-modal="closeDataloggerModal"
                    @form-submitted="refreshDataloggers"
                />
            </transition>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import PermissionsConsts from '../../common/permissions';
import ButtonComponent from '../../common/components/ButtonComponent.vue';
import Colors from '../../common/colors';
import ActionConfirmModal from '../../common/components/modals/ActionConfirmModal.vue';
import { filterList } from '../../common/utils';
import DataloggerModal from '../components/DataloggerModal.vue';

export default {
    name: 'DataloggersView',
    components: {
        SpeenComponent,
        ButtonComponent,
        ActionConfirmModal,
        DataloggerModal,
    },
    props: {
        dataloggersProp: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            showDataloggerModal: false,
            isNewDatalogger: false,
            selectedDatalogger: {},
            isLoading: false,
            currentPage: 1,
            perPage: 5,
            dataloggers: [],
            colors: Colors,
            actionConfirmModalMessage: '',
            methodForProp: null,
            showActionConfirmModal: false,
            filter: '',
        }
    },
    methods: {
        openDataloggerModal(datalogger) {
            if(datalogger) {
                this.selectedDatalogger = {
                    id: datalogger.id,
                    name: datalogger.name,
                    type: datalogger.type,
                    host: datalogger.host,
                    port: datalogger.port,
                    use_tls: datalogger.use_tls === 1 ? true : false,
                    username: datalogger.username,
                    password: datalogger.password,
                    client_id: datalogger.client_id
                };
                this.isNewDatalogger = false;
            } else {
                this.selectedDatalogger = {
                    name: '',
                    type: '',
                    host: '',
                    port: '',
                    use_tls: false,
                    username: '',
                    password: '',
                    client_id: ''
                };
                this.isNewDatalogger = true;
            }
            this.showDataloggerModal = true;
        },
        closeDataloggerModal() {
            this.showDataloggerModal = false;
        },
        getDataloggersVueData() {
            this.isLoading = true;
            axios.get('/api/datalogger')
                .then(response => {
                    this.dataloggers = response.data;
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        refreshDataloggers() {
            this.getDataloggersVueData();
        },
        confirmDeleteDatalogger(datalogger) {
            this.actionConfirmModalMessage = `¿Está seguro de que desea eliminar el datalogger ${datalogger.name}?`;
            this.methodForProp = () => {
                this.deleteDatalogger(datalogger.id);
            };
            this.openActionConfirmModal();
        },
        deleteDatalogger(dataloggerId) {
            axios.delete(`/api/admon/datalogger/${dataloggerId}`)
                .then(response => {
                    this.refreshDataloggers();
                    showCustomSuccessSweetAlert('Datalogger eliminado correctamente');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.closeActionConfirmModal();
                });
        },
        openActionConfirmModal() {
            this.showActionConfirmModal = true;
        },
        closeActionConfirmModal() {
            this.showActionConfirmModal = false;
        },
    },
    computed: {
        ...mapGetters(['isUserSuperadmin']),
        fields() {
            let baseFields = [
                { key: 'name', label: 'Nombre' },
                { key: 'type', label: 'Tipo' },
                { key: 'host', label: 'Host' },
                { key: 'port', label: 'Puerto' },
                { key: 'use_tls', label: 'Usa TLS'},
                { key: 'username', label: 'Nombre de usuario' },
                { key: 'client_id', label: 'Nombre de cliente' },
            ];
            if (this.showActionsColumn) {
                baseFields.push({ key: 'actions', label: 'Ajustes' });
            }
            return baseFields;
        },
        canEditDatalogger() {
            return this.isUserSuperadmin;
        },
        canDeleteDatalogger() {
            return this.isUserSuperadmin;
        },
        showActionsColumn() {
            return this.canEditDatalogger || this.canDeleteDatalogger;
        },
        canCreateDatalogger() {
            return this.isUserSuperadmin;
        },
        filteredList: function() 
        {
            return filterList(this.dataloggers, this.fields, this.filter);
        },
    },
    mounted() {
        this.getDataloggersVueData();
    }
}
</script>